/**
 * Swym + Kwikpass Integration
 * Intercepts Swym "Login to Save" and opens Kwikpass login.
 * Also refreshes Swym session state after successful Kwikpass login.
 */

if (typeof window !== "undefined") {
  const LOGIN_TRIGGER_SELECTOR =
    '[data-action="login"], .swym-storefront-layout-share-footer-login-btn, .swym-login-btn, [data-swym-action="login"], .swym-account-login';

  const closeSwymDrawer = () => {
    const swymLayout =
      window.SwymStorefrontLayoutExtensions?.SwymStorefrontLayout ||
      document.querySelector("swym-storefront-layout #swym-storefront-layout");

    if (swymLayout && typeof swymLayout.close === "function") {
      swymLayout.close();
      return;
    }

    const closeButton = document.querySelector(
      "#swym-storefront-layout-close-drawer-button",
    );

    if (closeButton) {
      closeButton.click();
    }
  };

  const openKwikpassLogin = () => {
    if (typeof window.handleKpAndShopifyLogin === "function") {
      window.handleKpAndShopifyLogin();
      closeSwymDrawer();
    } else {
      // Fallback if Kwikpass hasn't loaded yet — wait and retry once
      setTimeout(() => {
        if (typeof window.handleKpAndShopifyLogin === "function") {
          window.handleKpAndShopifyLogin();
          closeSwymDrawer();
        } else {
          // Final fallback: native Shopify login page
          window.location = "/account/login";
        }
      }, 500);
    }
  };

  const getSwymLoginTrigger = (event) => {
    const path =
      typeof event.composedPath === "function" ? event.composedPath() : [];

    for (const node of path) {
      if (!(node instanceof Element)) continue;

      if (node.matches(LOGIN_TRIGGER_SELECTOR)) {
        return node;
      }
    }

    return null;
  };

  const onDocumentClickCapture = (event) => {
    const trigger = getSwymLoginTrigger(event);
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openKwikpassLogin();
  };

  document.addEventListener("click", onDocumentClickCapture, true);

  // ------------------------------------------------------------------
  // Part 2: Refresh Swym session after successful Kwikpass login
  // Listens for the kp-data-sent event that Kwikpass fires post-login
  // ------------------------------------------------------------------

  const onKwikpassLoginSuccess = () => {
    if (window._swat && typeof window._swat.flushCustomerInfo === "function") {
      // Tell Swym to re-check the logged-in customer and refresh UI
      window._swat.flushCustomerInfo(function () {
        // If a wishlist drawer was open before login, re-open it
        if (window._swat.ui && typeof window._swat.ui.open === "function") {
          window._swat.ui.open();
        }
      });
    } else if (
      window.SwymCallbacks &&
      typeof window.SwymCallbacks === "object"
    ) {
      // Swym hasn't fully initialised yet — queue a refresh for when it does
      window.SwymCallbacks.push(function (swat) {
        swat.flushCustomerInfo(function () {
          if (swat.ui && typeof swat.ui.open === "function") {
            swat.ui.open();
          }
        });
      });
    } else {
      // Final fallback: reload so Shopify session is picked up by Swym
      window.location.reload();
    }
  };

  document.addEventListener("kp-data-sent", onKwikpassLoginSuccess);

  // ------------------------------------------------------------------
  // Part 3: Cart refresh integration for Swym add-to-cart
  // Re-apply a custom Swym AJAX cart hook after Swym initialises
  // ------------------------------------------------------------------

  const runSwymCartRefresh = () => {
    try {
      closeSwymDrawer();

      if (
        typeof publish === "undefined" ||
        typeof PUB_SUB_EVENTS === "undefined"
      ) {
        console.warn("[Swym Cart Refresh] Pub-sub event system not available");
        return;
      }

      document.body.dataset.cartAction = "added";
      document.body.dataset.cartItemsAdded = "1";
      document.body.classList.add("cart-items-added");

      publish(PUB_SUB_EVENTS.cartAdd);

      const miniCart = document.getElementById("mini-cart");
      if (miniCart && !miniCart.classList.contains("active")) {
        miniCart.dispatchEvent(new Event("drawer-toggle", { bubbles: true }));
      }
    } catch (error) {
      console.error("[Swym Cart Refresh] Error:", error);
    }
  };

  const assignSwymAjaxCartOverride = () => {
    window._SwymAJAXCart = runSwymCartRefresh;
  };

  assignSwymAjaxCartOverride();

  if (!Array.isArray(window.SwymCallbacks)) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(assignSwymAjaxCartOverride);
}
